const SQUARE = "square_inset";
const WIDE = "wide_inset";
const FULL = "full_bleed";

export default {
  SQUARE,
  WIDE,
  FULL
};
